import {
  ApplicationInsights,
  // DistributedTracingModes,
  ITelemetryPlugin
} from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

let reactPlugin: ReactPlugin | null = null; // Future add type
let appInsights: ApplicationInsights | null = null; // Future add type

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
  /**
   * Initialize the Application Insights class
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
   * @return {void}
   */
  const initialize = (instrumentationKey: string, browserHistory: History) => {
    // Future add type
    if (!browserHistory) {
      throw new Error('Could not initialize Telemetry Service');
    }
    if (!instrumentationKey) {
      throw new Error('Instrumentation key not provided');
    }

    reactPlugin = new ReactPlugin();

    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        enableResponseHeaderTracking: true,
        // disableCorrelationHeaders: false,
        // enableCorsCorrelation: true,
        // distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
        extensions: [reactPlugin as unknown as ITelemetryPlugin],
        // extensionConfig: {
        //   [reactPlugin.identifier]: {
        //     history: browserHistory
        //   }
        // }
      }
    });

    appInsights.loadAppInsights();
  };

  return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;

